/**
 * Price display helpers for billing.
 * Paid plans show "+VAT" before /month or /year (prices exclude VAT).
 */
export const PRICE_EXCLUDES_VAT = true;

/**
 * Returns the suffix for price display (e.g. "+VAT /month" or "/month")
 * @param {number} price - Plan/addon price (0 = free)
 * @param {'month'|'year'} cycle - Billing cycle
 * @returns {string}
 */
export function getPriceSuffix(price, cycle = 'month') {
  const period = cycle === 'year' ? '/year' : '/month';
  if (PRICE_EXCLUDES_VAT && price != null && price > 0) {
    return ` +VAT ${period}`;
  }
  return period;
}
